<div class="row" style="margin: 0px; background-color: white; width: 700px; border-radius: 25px;">
    <div class="col-md-12 col-12 col-sm-12" style="padding: 15px 15px 10px 15px; display: inline-block; border-bottom: 1px solid #dee2e6;">
        <div class="col-md-10 col-10 col-sm-10" style="padding: 0px; display: inline-block;">
            <h4 class="fnsize19" style="font-size:14px; color: #333 !important;">Update Invoice Status for</h4>
            <h4 class="fnsize25" style="font-size:27px;margin-top:0px;margin-bottom:0px; color: #333 !important;">
                {{agencyName}}
            </h4>
        </div>
        <div class="col-md-2 col-2 col-sm-2" style="padding: 0px; text-align: right; display: inline-block; vertical-align: top;">
            <i  (click)="closeInvoiceStatus()" class="closeMdl zmdi zmdi-close" style="padding: 8px 12px !important;float: right; font-size: 20px;" ></i>
        </div>        
    </div>
    <div class="col-md-12 col-12 col-sm-12" style="padding: 15px 15px 10px 15px; display: inline-block;">
        <table mat-table [dataSource]="dataSource" matSort style="width: 100%;border-radius: 10px;">
            <ng-container matColumnDef="InvoiceNo">
                <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef
                    mat-sort-header>
                    <label style="cursor: pointer; margin: 0px;">Invoice No.</label>
                </th>
                <td mat-cell *matCellDef="let item;let i=index"
                    style="text-align: left; width: 20%; cursor: pointer;">
                    {{item.DocNo }}</td>
            </ng-container>

            <ng-container matColumnDef="date">
                <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef
                    mat-sort-header>
                    Date
                </th>
                <td mat-cell *matCellDef="let item ;let i=index" style="text-align: left; cursor: pointer;width: 15%;">
                    {{ item.DocDate | todayTommorow}}
                </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th class="header header-Table" style="cursor: pointer; " mat-header-cell *matHeaderCellDef
                    mat-sort-header>
                    <label style="cursor: pointer; margin: 0px;">Status</label>
                </th>
                <td mat-cell *matCellDef="let item ;let i=index"
                    style="text-align: left; width: 20%; cursor: pointer;">
                    <select class="form-control" [(ngModel)]="item.status" (ngModelChange)="fn_changePaymentStatus(i);">
                        <option value="Fully Paid">Fully Paid</option>
                        <option value="Partly Paid">Partly Paid</option>
                        <option value="Unpaid">Unpaid</option>
                    </select>
                </td>
            </ng-container>

            <ng-container matColumnDef="pndgAmt">
                <th class="header header-Table" style="cursor: pointer;" arrowPosition='before' mat-header-cell *matHeaderCellDef
                    mat-sort-header>
                    <label style="cursor: pointer; margin: 0px;">Pending Amt (₹)</label>
                </th>
                <td mat-cell *matCellDef="let item ;let i=index" style="padding-left: 25px; cursor: pointer; text-align: right; width: 20%;">
                    {{item.PndgAmt | lacFormat }}
                </td>
            </ng-container>

            <ng-container matColumnDef="recdAmt">
                <th class="header header-Table" style="cursor: pointer;" arrowPosition='before' mat-header-cell *matHeaderCellDef
                    mat-sort-header>
                    <label style="cursor: pointer; margin: 0px;">Received Amt (₹)</label>

                </th>
                <td mat-cell *matCellDef="let item ;let i=index" style="padding-left: 25px; cursor: pointer; text-align: right; width: 25%;">
                    <input class="form-control" [(ngModel)]="item.receivedAmt" (blur)="fn_changeRecoveryAmt(i);" style="text-align: right;" maxlength="12" appTwoDecimalNumber>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let item; columns: displayedColumns"></tr>
        </table>

        <!-- Angular 8 pagination -->
        <mat-paginator #paginator [pageSize]="5" [pageSizeOptions]="[5,10, 20]" showFirstLastButtons>
        </mat-paginator>
    </div>

    <div class="col-md-12 col-12 col-sm-12" style="padding: 15px 15px 10px 15px; display: inline-block;">
        <span class="btn btn-save" (click)="fn_SaveUpdateInvStatus()" 
            style="font-size: 13px; padding: 2px 7px 2px; line-height: 1.66em;">
            <i class="fa fa-check" style="margin-right: 5px;"></i>
            <span>Save</span>
        </span>
    </div>
</div>